import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'age', 'maxHr', 'restingHr', 'method',
    'maxHrDisplay',
    'zone1Low', 'zone1High',
    'zone2Low', 'zone2High',
    'zone3Low', 'zone3High',
    'zone4Low', 'zone4High',
    'zone5Low', 'zone5High'
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const age = parseInt(this.ageTarget.value, 10) || 30
    const inputMaxHr = parseInt(this.maxHrTarget.value, 10)
    const restingHr = parseInt(this.restingHrTarget.value, 10) || 0
    const method = this.methodTargets.find((r) => r.checked)?.value || 'percentage'

    // Calculate max HR using Tanaka formula if not provided
    const maxHr = inputMaxHr || Math.round(208 - (0.7 * age))
    this.maxHrDisplayTarget.textContent = maxHr

    // Zone percentages
    const zones = [
      { low: 0.50, high: 0.60 },
      { low: 0.60, high: 0.70 },
      { low: 0.70, high: 0.80 },
      { low: 0.80, high: 0.90 },
      { low: 0.90, high: 1.00 }
    ]

    if (method === 'karvonen' && restingHr > 0) {
      // Karvonen formula: Target HR = ((Max HR - Resting HR) x % intensity) + Resting HR
      const hrReserve = maxHr - restingHr

      zones.forEach((zone, i) => {
        const lowTarget = this[`zone${i + 1}LowTarget`]
        const highTarget = this[`zone${i + 1}HighTarget`]

        lowTarget.textContent = Math.round((hrReserve * zone.low) + restingHr)
        highTarget.textContent = Math.round((hrReserve * zone.high) + restingHr)
      })
    } else {
      // Simple percentage method
      zones.forEach((zone, i) => {
        const lowTarget = this[`zone${i + 1}LowTarget`]
        const highTarget = this[`zone${i + 1}HighTarget`]

        lowTarget.textContent = Math.round(maxHr * zone.low)
        highTarget.textContent = Math.round(maxHr * zone.high)
      })
    }
  }
}
